<template>
  <report-section title="HRV" class="hrv-field-section">
    <template v-slot:content>
      <div class="section-hrv-content">
        <div class="params-grid">
          <div class="param-item">
            <span class="param-label">SDNN:</span>
            <span class="param-value">{{ formatNumberFloor(reportDetailModel.hrvData?.sdnn) }}</span>
          </div>
          <div class="param-item">
            <span class="param-label">SDANN:</span>
            <span class="param-value">{{ formatNumberFloor(reportDetailModel.hrvData?.sdann) }}</span>
          </div>
          <div class="param-item">
            <span class="param-label">rMSSD:</span>
            <span class="param-value">{{ formatNumberFloor(reportDetailModel.hrvData?.rmssd) }}</span>
          </div>
          <div class="param-item">
            <span class="param-label">NN50:</span>
            <span class="param-value">{{ reportDetailModel.hrvData?.nn50 || '-' }}</span>
          </div>
          <div class="param-item">
            <span class="param-label">pNN50:</span>
            <span class="param-value">{{ formatNumberFloor(reportDetailModel.hrvData?.pnn50) }}</span>
          </div>
          <div class="param-item">
            <span class="param-label">TriangleIdx:</span>
            <span class="param-value">{{ formatNumberFloor(reportDetailModel.hrvData?.triangleIdx) }}</span>
          </div>
          <div class="param-item">
            <span class="param-label">LHFR:</span>
            <span class="param-value">{{ formatNumberFloor(reportDetailModel.hrvData?.lhfr) }}</span>
          </div>
        </div>
      </div>
    </template>
  </report-section>
</template>

<script>
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
import { formatNumberFloor } from "@js/common-tool.js";

export default {
  components: {
    ReportSection
  },

  props: {
    reportDetailModel: Object
  },

  methods: {
    formatNumberFloor
  }
};
</script>

<style lang="scss" scoped>
.hrv-field-section {
  /deep/ .report-section-title-text {
    @include report-section-title;
  }
}

.section-hrv-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 180px;
  padding: 0;
}

.params-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  
  @media print {
    gap: 6px;
  }
}

.param-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px 10px;
  width: calc(42% - 4px); // 两列布局，减去gap的一半
  box-sizing: border-box;
  
  .param-label {
    font-size: 16px;
    color: #000;
    white-space: nowrap;
  }
  
  .param-value {
    font-size: 16px;
    color: #000;
    font-weight: 500;
  }
}

@media print {
  .hrv-field-section {
    /deep/ .report-section-title-text {
      @include report-section-title-print;
    }
  }
  
  .section-hrv-content {
    min-height: 200px;
  }
}
</style> 